'use client';

import { OverlayProvider } from 'overlay-kit';

export default function OverlayKitProvider({ children }: { children: React.ReactNode }) {
  return <OverlayProvider>{children} </OverlayProvider>;
}
